import L from 'leaflet';

export const markerIcon = (number, isInCart, hasSeen) => {
  let html = '<div class="map__marker"></div>';
  let size = [18, 18];
  let anchor = [9, 18];

  if (isInCart) {
    html = `<div class="map__marker is-in-cart" ${number ? `data-number="${number}"` : ''}></div>`;
    size = [28, 56];
    anchor = [14, 56];
  } else if (hasSeen) {
    html = '<div class="map__marker has-seen"></div>';
  }

  return L.divIcon({
    html,
    iconSize: size,
    iconAnchor: anchor,
  });
};

export const popup = (data) => {
  let url = '';
  let price = '';
  let caption = '';
  let modalToggler = '';

  if (data.caption) {
    caption = `
      <div class="font-size-xxs mt-2">
        ${data.caption}
      </div>
    `;
  }

  if (data.price) {
    price = `
      <div class="color-primary font-size-xxs font-weight-bold mt-1">
        ${data.price}
      </div>
    `;
  }

  if (data.url) {
    url = `
      <a
        href="${data.url}?map=1"
        class="mt-2 btn btn--sm btn--primary"
      >
        ${window.app.i18n.view}
      </a>
    `;
  }

  if (data.modelId && data.modelClass && data.withModal) {
    modalToggler = `
      <button
        type="button"
        class="mt-2 btn btn--sm btn--primary"
        data-action="click->modal#onTogglerClick"
        data-model-type="${data.modelClass}"
        data-model-id="${data.modelId}"
      >
        ${window.app.i18n.moreInfo}
      </button>
    `;
  }

  return `
    <div class="media-item">
      <div class="position-relative overflow-hidden ratio--3-2 mb-2">
        <img
          src="${data.image}"
          alt="${data.title}"
          class="img-fit absolute-center"
          loading="lazy"
        >
      </div>

      <div class="media-item__content">
        <div class="color-text-dark font-size-xxs font-weight-bold">
          ${data.title}
        </div>

        ${caption}

        ${price}

        ${url}

        ${modalToggler}
      </div>
    </div>
  `;
};

export const popupOptions = {
  className: 'map__popup',
};
